<template>
    
    <b-row>
        <b-col md="12" class="mt-3">
            <div slot="header">
              <b-row>
                  <b-col>
                    <center>
                    <strong> OverTime Status</strong> 
                    </center>
                    </b-col>
              </b-row>   
          </div>
    <div id="listloader" v-if="isloader">
            <div class="listloader"></div>
        </div>
    <!-- <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">            
        <b-row> 
            <b-col sm="6">
            <b-form-group label="Date Period :"  :label-cols="3" >
                <date-picker :clearable="false"  name="startdate endate" v-model="time3" :placeholder="['Start date', 'End date']"   range ></date-picker>


             </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Shift:"  :label-cols="3" >
                
                <b-form-select  v-model="shiftdata" name="status">
                    <option :value="selected" disabled>--Select--</option>
                    <option v-for="pallet in shiftlist" v-bind:value="pallet.shiftname.toLowerCase()">{{ pallet.shiftname}}</option>
                  </b-form-select>

            </b-form-group>
          </b-col>
       
          
        </b-row>
        
        <b-row>
          <b-col sm="4" >
            <b-col sm="12">
            
            </b-col>
          </b-col>
           <b-col sm="8" class="my-1 text-right">
            
            <b-form-group>
             <b-button type="submit" size="md" variant="primary" @click="getreportdata()"> Search</b-button>
           
              <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
           
             
            </b-form-group>
          
          </b-col>
           

        </b-row>
       
      </b-form>        -->
        <div class="container px-0">
            <div class="row">
                <div class="col-xl-12 col-18">
                <div class="card">
                    <div class="card-body p-1">
                        <div id="chart"></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    
        </b-col>
    </b-row>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts';
import $ from 'jquery';
import Chart from 'chart.js/auto'; // or 'chart.js'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { cosh } from 'core-js/core/number';
export default {
components:{
    VueApexCharts,
    apexchart: VueApexCharts,
    DatePicker,
    VueTimepicker
},
data() {
    return {
        isBusy: false, 
      
        fields :[],
        EBN_expriryCount :[],
        isBusy : false,
        noofpages:'',
        pageNum:1,
        searching :[],
        searchvaluesarr:[],
        totalRows :0,
        CheckLoadID :[],
        SelectLoadID :[],
        selectDateFrom: '',
        route_id : null,
        isCheckAll: false,
        //time3: [new Date(), new Date()],
        starttime:'',
        endtime:'',
        customFormat: 'yyyy-MM-dd',
        selected:'',
        // shiftdata:'1st',
        // listdata:[],
         isloader : false,
        // shiftlist :[],
        chartnorecords :{"" : {"Hours":0,"Users":0,"hubid":''}}  

    }
},
props:{
    chartdata_overtime:{
        type:Array,
        required:false
    },
    shiftdata:{
        type:String,
        required:true
    },
    time3:{
        type:Array,
        required:true
    }

},
created() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.User_type = userInfo.user_type;
    //console.log("userInfo", userInfo);
    this.route_id = this.$route.params.id;
  //  console.log("this.route_id",this.route_id)
  
    // this.manuallyUpdateRecord();
},
mounted(){
    
   // this.getreportdata()
  this.getshowbarcharts();
   //this.getshiftdata()
},
watch: {
    chartdata_overtime: 'getshowbarcharts'
    },
methods: {
    getshowbarcharts() {

        this.statusMap = {};
            this.ageGroups = ['Hours', 'Users'];
        this.chartdata_overtime.forEach(item => {
        if (!this.statusMap[item.hubname]) {
            this.statusMap[item.hubname] = { };
            this.ageGroups.forEach(ageGroup => {
                this.statusMap[item.hubname][ageGroup] = 0;
            });
        }
        this.statusMap[item.hubname]['Hours'] = (parseInt(item.overtimesum)/3600).toFixed(2);
         this.statusMap[item.hubname]['Users'] =  (item.empcount);
 
         this.statusMap[item.hubname]['hubid'] =  (item.premiseid);

    });
    let datac = this.chartdata_overtime.length > 0 ?  this.statusMap : this.chartnorecords
        // console.log('datac-------->>>>k>>>',datac)
let statusKeys = Object.keys(datac);

if (statusKeys.length > 0) {
    let agingKeys = Object.keys(datac[statusKeys[0]]);
    
     let colors = ['#fc7303', '#008FFB', '#FEB019', '#FF4560', '#775DD0', '#00D8B6', '#008000'];

     agingKeys = agingKeys.filter(i=>i !='hubid')
    let seriesData = agingKeys.map((aging, index) => ({
             name: aging,
            data: statusKeys.map(status => {
                let count = datac[status][aging];
                return count !== undefined ? count : 0;
            }),
            color: colors[index],
            hiddenValues: statusKeys.map(status => {
            // Assuming datac[status][`${aging}_hidden`] holds the hidden value
            let hiddenValue = datac[status]['hubid'];
            return hiddenValue !== undefined ? hiddenValue : null;
        })
        }));
        //console.log('seriesData=======>>>>>>>',seriesData)
        let dynamicheight = statusKeys && statusKeys.length > 4 ? 300 : 150 
      let options = {
          series: seriesData,
          chart: {
              type: 'bar',
              height: dynamicheight,
              events: {
        dataPointSelection: (event, chartContext, config) => {
            // console.log('chartContext======',chartContext)
            // console.log('event------>>',event)
        //    console.log('config===>',config)
           let seriesIndex = config.seriesIndex;
        //    console.log('seriesIndex=',seriesIndex)
         //  console.log('config.dataPointIndex===>',config.dataPointIndex)
        //  console.log('=statusKeys============',statusKeys)
           let status = statusKeys[config.dataPointIndex];

          let hiddenValue = config.w.config.series[seriesIndex].hiddenValues[config.dataPointIndex];
                    
        let timerangedata = this.time3
        let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
        let shiftstartdate = this.formatDate(timerangedata[0])
        let shiftenddate = this.formatDate(timerangedata[1])

        let newPageUrl = this.$router.resolve({ path: '/fcclock_datatable/overtimestatus'+ '/' + hiddenValue+'/'+shift+'/'+shiftstartdate+'/'+shiftenddate }).href;
        window.open(newPageUrl, '_blank');
        }
      }
          },
          plotOptions: {
              bar: {
                  horizontal: true,
                  dataLabels: {
                      position: 'top',
                  },
                  borderRadius: 2, 
                  barHeight: '70%',

              },
          },
          dataLabels: {
              enabled: true,
              offsetX: -6,
              style: {
                  fontSize: '14px',
                  colors: ['#fff'],
              },
          },
          stroke: {
              show: true,
              width: 1,
              colors: ['#fff'],
          },
          tooltip: {
              shared: true,
              intersect: false,
          },
          xaxis: {
              categories: statusKeys,
              labels: {
                  style: {
                      fontSize: '12px', 
                      fontWeight: 'bold',
                  }
              }
          },
          yaxis: {
              labels: {
                  style: {
                      fontSize: '12px', 
                      fontWeight: 'bold',
                  },
                  offsetX: 10
              }
          },
          
      };
      if (this.chart) {
          this.chart.destroy();
      }
      let chartContainer = document.querySelector('#chart');
      this.chart = new ApexCharts(chartContainer, options);
      this.chart.render();
  }
},
chartClickHandler(event) {
  const activePoints = this.barChartExample2.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);
   if (activePoints.length > 0) {
   
    const clickedDatasetIndex = activePoints[0].datasetIndex;
    const clickedElementIndex = activePoints[0].index;

  
    const label = this.barChartExample2.data.labels[clickedElementIndex];
    const value = this.barChartExample2.data.datasets[clickedDatasetIndex].data[clickedElementIndex];
    

    let splithubname = label.split('\n');
     // this.$router.push({ path: '/fcclock_datatable/'+label+'/'+ value });
    let newPageUrl = this.$router.resolve({ path: '/fcclock_datatable/attendance'+ '/' + splithubname[1] }).href;
    window.open(newPageUrl, '_blank');
  }
},
// clear(){
//     this.starttime = {'HH':'', 'mm':''}
//     this.endtime = {'HH':'', 'mm':''}
//     this.time3 = [new Date(), new Date()]
//     this.shiftdata= '1st'
//     this.listdata = []
//     this.getreportdata()

// },  getreportdata(){
//     this.isloader = true
//     let timerangedata = this.time3  
//     let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
//     let shiftstartdate = timerangedata[0]
//     let shiftenddate = timerangedata[1]

//     var fromdate = (shiftstartdate!=null)?this.formatDate(shiftstartdate):"";
//     var formatdateto=(shiftenddate!=null)? this.formatDate(shiftenddate):"";

//         var Obj = {       
//             startdate : fromdate,
//             enddate : formatdateto,
//             shift : shift
//         };
      
      
//         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getOvertimestatusviewReport`, Obj)
//         .then(result => {
//            // this.isBusy = false;
//            this.isloader = false
//             if (result.body.returnmsg.toLowerCase() === 'successful') {
               
//              this.statusMap = {};
//             this.ageGroups = ['Hours', 'Users'];
//         result.body.returnvalue.forEach(item => {
//         if (!this.statusMap[item.hubname]) {
//             this.statusMap[item.hubname] = { };
//             this.ageGroups.forEach(ageGroup => {
//                 this.statusMap[item.hubname][ageGroup] = 0;
//             });
//         }
//         this.statusMap[item.hubname]['Hours'] = (parseInt(item.overtimesum)/3600).toFixed(2);
//          this.statusMap[item.hubname]['Users'] =  (item.empcount);
 
//          this.statusMap[item.hubname]['hubid'] =  (item.premiseid);

//     });
//             this.getshowbarcharts(this.statusMap)

//             } 
//             else {
//             let b = {"" : {"Hours":0,"Users":0,"hubid":''}}    
//             this.getshowbarcharts(b);
//         }
                
    
//         })
//         .catch(ex => {
//             console.log("error-----", ex);
//         });


// },
// getshiftdata(){
//         var Obj = {};
//         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshiftlist`, Obj)
//         .then(result => {
//            // this.isBusy = false;
//            this.isloader = false
//             if (result.body.returnmsg.toLowerCase() === 'successful') {
//               this.shiftlist = result.body.returnvalue
//             } 
//             else {
//              this.shiftlist =  []
//             }
//         })
//         .catch(ex => {
//             console.log("error-----", ex);
//         });
// },
validateForm(scope) {
       
        this.errors.clear('form-1')
        this.$validator.validateAll(scope).then((result) => {
            if (result) {

            }
        })
    },
    formatDate: function(date) {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");

    }

},

}
</script>

